// The client side of /api/search (BUILD-BRIEF-R2 §6) — owned by the `search` agent.
//
// `fresh: true` skips the index and asks a provider. It costs money and it leaves the house,
// so it is a SEPARATE VERB on the page ("Search live"), never a silent fallback behind the
// ordinary one.
import { qs, request } from './client.js';
import type { Search, SearchResponse, SearchStats } from '../../shared/types.js';

export function search(q: string, fresh = false, purpose?: string): Promise<SearchResponse> {
  return request(`/search${qs({ q, fresh: fresh ? '1' : '', purpose: purpose ?? '' })}`);
}

export function searchStats(): Promise<SearchStats> {
  return request('/search/stats');
}

/** The Recent queries table: what was asked, how it was answered, what it cost. */
export function recentSearches(limit = 20): Promise<{ items: Search[]; total: number }> {
  return request(`/search/recent${qs({ limit })}`);
}
